export function localDateValue(date = new Date()) {
  const base = date instanceof Date ? date : new Date(date || Date.now());
  const year = base.getFullYear();
  const month = String(base.getMonth() + 1).padStart(2, "0");
  const day = String(base.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function localDateFromValue(value) {
  const [year, month, day] = String(value || localDateValue()).split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function addDays(dateValue, days) {
  const date = localDateFromValue(dateValue);
  date.setDate(date.getDate() + days);
  return localDateValue(date);
}

export function formatDate(date) {
  if (!date) return "";
  const [year, month, day] = String(date).split("-");
  return `${day}/${month}/${year}`;
}
